export function imagePlaceholderUrl(x: number, y?: number) {
  return !y ? `https://placehold.co/${x}` : `https://placehold.co/${x}x${y}`;
}

const picsumIds = ['41', '75', '133', '292', '360', '284', '504'] as const;

export function randomImagePlaceholderUrl(
  rand: keyof typeof picsumIds,
  x: number,
  y?: number,
) {
  return `https://picsum.photos/id/${picsumIds[rand]}/${x}/${y || x}`;
}
